import BUApi from './_buApi';
import httpClient from '@/apis/base/httpclient';

class BUPlanImportAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUPlanImports';

  /**
   *  Dữ  liệu nhập dự toán
   * NTLOC 03.06.2022
   */
  getBUPlanImport(param) {
    let request = {
      url: this.getAPIUrl() + '/BUPlanImport',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new BUPlanImportAPI();
